import Animation from './animation'


class ExitingAnimation extends Animation {

  constructor (options) {
    super(options)
  }

  match (serie) {
    return this.seriesChanged && // Series changed
           this.exitingSeries.selection().data().indexOf(serie) !== -1 // this serie is part of the exiting selection
  }

  animate (serie, enter, selection, merged, exit) {
    let duration = this._hasFills(serie) ? (this.timing.duration / 2) : this.timing.duration
      , self = this

    selection.selectAll('path.fill')
             .transition()
             .duration(duration)
             .attr('d', d => this.flatArea(d.points))
             .end().then(() => {
               // Remove the line
               let lines = selection.selectAll('path.line')
               lines.transition()
                    .duration(duration)
                    .tween('shrink', () => {
                      let interpolater = this._getLineInterpolater(serie, lines)
                      return t => interpolater(1 - t)
                    })
             })

  }

}

export default ExitingAnimation

